<template>
  <div>
    <button
      style="display: none"
      type="button"
      class="btn-confirm-modal-donate"
      data-bs-toggle="modal"
      data-bs-target="#bottom_modal_confirm_donate"
    ></button>
    <div
      class="modal modal-bottom fade"
      id="bottom_modal_confirm_donate"
      tabindex="-1"
      role="dialog"
      aria-labelledby="bottom_modal_confirm_donate_title"
      style="z-index: 10000"
    >
      <div class="modal-dialog" role="document">
        <!-- MBR061 Heritage Hearth confirm sheet (no design reference: follows ModalConfirm / TopupCompleted) -->
        <div class="modal-content mbr-donate-confirm">
          <div class="mbr-donate-confirm__top">
            <span class="mbr-donate-confirm__handle" aria-hidden="true"></span>
            <button
              type="button"
              class="btn-close-confirm-modal mbr-donate-confirm__close"
              data-bs-dismiss="modal"
              :aria-label="$t('common.close')"
            >
              <svg fill="none" stroke="currentColor" stroke-width="2.2" viewBox="0 0 24 24" aria-hidden="true"><path stroke-linecap="round" stroke-linejoin="round" d="M6 18L18 6M6 6l12 12" /></svg>
            </button>
          </div>
          <div class="modal-body mbr-donate-confirm__body">
            <span class="mbr-donate-confirm__icon" aria-hidden="true">
              <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8">
                <path d="M12 21.35l-1.45-1.32C5.4 15.36 2 12.28 2 8.5 2 5.42 4.42 3 7.5 3c1.74 0 3.41.81 4.5 2.09C13.09 3.81 14.76 3 16.5 3 19.58 3 22 5.42 22 8.5c0 3.78-3.4 6.86-8.55 11.54L12 21.35z" />
              </svg>
            </span>
            <span id="bottom_modal_confirm_donate_title" class="mbr-donate-confirm__eyebrow">{{ $t('donation.amount_to_donate') }}</span>
            <div class="mbr-donate-confirm__amount">$ {{ formattedAmount }}</div>
          </div>
          <!-- plain <button>: <material-button> was never registered here and rendered as an unknown tag -->
          <div class="mbr-donate-confirm__actions">
            <button
              type="button"
              class="mbr-donate-confirm__btn mbr-donate-confirm__btn--ghost close-model"
              data-bs-dismiss="modal"
            >
              {{ $t('common.no') }}
            </button>
            <button
              type="button"
              class="mbr-donate-confirm__btn mbr-donate-confirm__btn--primary mbr-donate-confirm__yes"
              @click="sycnProfile"
            >
              {{ btnYes }}
            </button>
          </div>
        </div>
      </div>
      <button
        class="btn-share-profile-modal"
        style="display: none"
        data-bs-toggle="modal"
        data-bs-target="#bottom_modal_confirm_donate"
      >
        Success
      </button>
    </div>
  </div>
</template>

<script>
export default {
  name: "ModalConfirmDonate",
  props: {
    id: {
      type: String,
      required: true,
    },
    amount: {
      type: Number,
      default: 0,
    },
    btnYes: {
      type: String,
      default: "",
    },
    sycnProfile: {
      type: Function,
      default: () => {},
    },
  },
  computed: {
    formattedAmount() {
      return (parseFloat(this.amount) || 0).toFixed(2);
    },
  },
};
</script>
<style scoped>
/* Bottom sheet mechanics (the only modal variant this component uses) */
.modal.modal-bottom .modal-dialog {
  position: fixed;
  width: 100%;
  max-width: 100%;
  height: auto;
  margin: auto;
  transform: translate3d(0%, 0, 0);
}

.modal.modal-bottom.fade .modal-dialog {
  bottom: -100%;
  transition: opacity 0.3s linear, bottom 0.3s ease-out;
}

.modal.modal-bottom.fade.show .modal-dialog {
  bottom: 0;
}

/* MBR061 Heritage Hearth sheet */
.modal.modal-bottom .modal-content.mbr-donate-confirm {
  max-width: 440px;
  height: auto;
  margin: 0 auto;
  padding: 12px 24px calc(28px + env(safe-area-inset-bottom));
  background: var(--mbr-color-surface);
  border: 0;
  border-top: 1px solid rgba(var(--mbr-color-outline-rgb), 0.5);
  border-radius: 32px 32px 0 0;
  box-shadow: var(--mbr-shadow-modal);
  font-family: var(--mbr-font-body);
  color: var(--mbr-color-ink-headline);
}

.mbr-donate-confirm :where(:not(.material-icons-round)) {
  font-family: var(--mbr-font-body);
}

.mbr-donate-confirm__top {
  position: relative;
  display: flex;
  justify-content: flex-end;
  min-height: 36px;
}

.mbr-donate-confirm__handle {
  position: absolute;
  top: 0;
  left: 50%;
  width: 40px;
  height: 4px;
  background: var(--mbr-color-outline);
  border-radius: var(--mbr-radius-full);
  transform: translateX(-50%);
}

.mbr-donate-confirm__close {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 36px;
  height: 36px;
  padding: 0;
  background: var(--mbr-color-tint);
  border: 1px solid rgba(var(--mbr-color-outline-rgb), 0.5);
  border-radius: var(--mbr-radius-full);
  color: var(--mbr-color-ink-secondary);
}

.mbr-donate-confirm__close svg {
  width: 16px;
  height: 16px;
}

.modal.modal-bottom .modal-body.mbr-donate-confirm__body {
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 0 0 28px;
  text-align: center;
}

.mbr-donate-confirm__icon {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 56px;
  height: 56px;
  margin-bottom: 14px;
  border-radius: var(--mbr-radius-full);
  background: var(--mbr-color-peach);
  color: var(--mbr-color-primary);
}

.mbr-donate-confirm__icon svg {
  width: 26px;
  height: 26px;
}

.mbr-donate-confirm__eyebrow {
  font-size: 11px;
  font-weight: 700;
  line-height: 14px;
  letter-spacing: 0.08em;
  text-transform: uppercase;
  color: var(--mbr-color-ink-secondary);
}

.mbr-donate-confirm__amount {
  margin-top: 6px;
  font-family: var(--mbr-font-headline) !important;
  font-size: 36px;
  font-weight: 800;
  line-height: 44px;
  letter-spacing: -0.02em;
  color: var(--mbr-color-primary);
}

.mbr-donate-confirm__actions {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 12px;
}

.mbr-donate-confirm__btn {
  display: flex;
  align-items: center;
  justify-content: center;
  min-height: 56px;
  padding: 8px 20px;
  border-radius: var(--mbr-radius-full);
  font-family: var(--mbr-font-headline) !important;
  font-size: 16px;
  font-weight: 700;
  line-height: 1.25;
  transition: transform 0.15s ease, background-color 0.15s ease;
}

.mbr-donate-confirm__btn:active {
  transform: scale(0.98);
}

.mbr-donate-confirm__btn--ghost {
  background: transparent;
  border: 1.5px solid var(--mbr-color-outline);
  color: var(--mbr-color-ink-headline);
}

.mbr-donate-confirm__btn--primary {
  background: var(--mbr-color-primary);
  border: 1.5px solid var(--mbr-color-primary);
  box-shadow: 0 8px 20px -4px rgba(var(--mbr-color-primary-rgb), 0.35);
  color: var(--mbr-color-on-primary);
}

.mbr-donate-confirm__btn--primary:hover {
  background: var(--mbr-color-primary-light);
}

.mbr-donate-confirm__close:focus-visible,
.mbr-donate-confirm__btn:focus-visible {
  outline: 2px solid var(--mbr-color-primary);
  outline-offset: 2px;
}
</style>
